import { useClientStore } from '@/stores/ClientStore.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import { router, ROUTES } from '@/router.ts';
import { requestInputSourcesAction } from '@/actions/electron/RequestInputSourcesAction.ts';
import { requestDesktopAppVersionAction } from '@/actions/electron/RequestDesktopAppVersionAction.ts';

export const resetAction = async (navigateToStartPage: boolean) => {
    const clientStore = useClientStore();

    clientStore.$patch((state) => {
        state.streams = {};
        state.streamsWaiting = [];
        state.streamsInProgress = [];
        state.streamsErrored = [];
        state.streamsEnded = [];
        state.streamErrors = {};
        state.streamStartDates = {};
        state.sessionVariables = {};
        state.verticalNavigationOptions = {};
        state.verticalNavigationSelection = {};
        state.activeSessionId = undefined;
        state.activeProfileId = undefined;
        state.screenCapturesBySession = {};
        state.screenCaptureRevisions = {};
    });

    const sessionStore = useSessionStore();
    sessionStore.isFullLoading = false;

    void requestInputSourcesAction();
    void requestDesktopAppVersionAction();

    if (navigateToStartPage) {
        await router.push({ name: ROUTES.index });
    }
};
